const UNICODE_FLAG_POINT_START = 127397

export function flag (code: string | null | undefined): string | null {
  if (code == null) return null

  return String.fromCodePoint(UNICODE_FLAG_POINT_START + code.charCodeAt(0), UNICODE_FLAG_POINT_START + code.charCodeAt(1))
}
